var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "journal" } }, [
    _c("div", { staticClass: "container-1200" }, [
      _c(
        "div",
        { staticClass: "content journal-inner" },
        [
          _c(
            "header",
            { staticClass: "page-header" },
            [
              _c("dashboard-header", {
                attrs: {
                  title: _vm.$t("sidebar.businessPlan"),
                  "quick-tour-visible": _vm.quickTourVisible,
                  "hide-guide-button": "",
                  "flex-column": false,
                },
                on: { "toggle-quick-tour": _vm.toggleQuickTour },
                scopedSlots: _vm._u([
                  {
                    key: "actions",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "d-flex" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "export-share-button d-flex justify-content-center align-items-center",
                            },
                            [
                              !_vm.canExportShare
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "d-flex align-items-center",
                                      on: { click: _vm.showUpgradeDialog },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "ib-icon-download h3 color-font-light",
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-none d-lg-flex ml-2 color-font-light font-outfit-regular",
                                        },
                                        [_vm._v(_vm._s(_vm.$t("export")))]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "el-dropdown",
                                    {
                                      attrs: { trigger: "click" },
                                      on: { command: _vm.generateDocument },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "d-flex align-items-center el-dropdown-link print",
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "ib-icon-download h3 color-font-light",
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-none d-lg-flex ml-2 color-font-light font-outfit-regular",
                                            },
                                            [_vm._v(_vm._s(_vm.$t("export")))]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-menu",
                                        {
                                          staticClass: "export-dropdown-menu",
                                          attrs: { slot: "dropdown" },
                                          slot: "dropdown",
                                        },
                                        [
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              staticClass: "d-flex",
                                              attrs: {
                                                icon: "ib-icon-export-pdf",
                                                command: "pdf",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("exportToPdf")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-dropdown-item",
                                            {
                                              staticClass: "d-flex",
                                              attrs: {
                                                icon: "ib-icon-export-word",
                                                command: "doc",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("exportToWord")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "export-share-button d-flex justify-content-center align-items-center ml-3",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "d-flex align-items-center",
                                  on: { click: _vm.shareJournal },
                                },
                                [
                                  _vm.shareLoading
                                    ? _c("i", {
                                        staticClass: "el-icon-loading",
                                      })
                                    : _vm._e(),
                                  !_vm.shareLoading
                                    ? _c("i", {
                                        staticClass:
                                          "ib-icon-share h3 color-font-light",
                                      })
                                    : _vm._e(),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-none d-lg-flex ml-2 color-font-light font-outfit-regular",
                                    },
                                    [_vm._v(_vm._s(_vm.$t("share")))]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("hr"),
            ],
            1
          ),
          _c("div", { staticClass: "height-holder d-none d-md-block" }),
          _c(
            "quick-tour-card-wrapper",
            {
              attrs: { active: _vm.quickTourVisible, closable: "" },
              on: { close: _vm.onCloseQuickTour },
            },
            [_c("business-plan-quick-tour")],
            1
          ),
          _vm.sidebarSmallScreen && _vm.isPageContentVisible
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-end mb-3" },
                [
                  _c(
                    "ib-tooltip",
                    {
                      staticClass: "ml-4",
                      attrs: {
                        "popper-class": "medium center",
                        content: _vm.$t("pages.businessPlan.addNewPage"),
                      },
                    },
                    [
                      _vm.canEdit
                        ? _c("el-button", {
                            staticClass: "width-fix add-new-button",
                            class: { "d-none": !_vm.sidebarSmallScreen },
                            attrs: {
                              disabled: _vm.addButtonDisabled,
                              type: "plus-round-xs",
                              icon: "el-icon-plus",
                            },
                            on: { click: _vm.addCustomPage },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "ib-button",
                    {
                      ref: "outlineBtnRef",
                      staticClass: "ml-3 p-3",
                      attrs: {
                        "icon-right": "",
                        "icon-rotate": "",
                        "force-icon-rotated": "",
                        "font-family": "medium",
                        icon: "el-icon-arrow-down",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.clickOnMenuBtn.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("pages.businessPlan.outline")) + " "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isPageContentVisible
            ? _c("div", { ref: "journal-flex", staticClass: "journal-flex" }, [
                _c(
                  "div",
                  {
                    ref: "journal-wrapper",
                    staticClass: "journal-content-wrapper",
                  },
                  [
                    _vm._l(
                      _vm.businessPlanSections,
                      function (componentEl, index) {
                        return [
                          !_vm.loaded[_vm.lcfirst(componentEl.sectionName)]
                            ? _c("loader", { key: index })
                            : _vm._e(),
                          _vm.loaded[_vm.lcfirst(componentEl.sectionName)]
                            ? [
                                componentEl.sectionName
                                  ? _c(componentEl.sectionName, {
                                      key: componentEl.id,
                                      tag: "component",
                                      attrs: {
                                        id: componentEl.id,
                                        "all-pages-text-data": componentEl,
                                      },
                                      on: {
                                        save: _vm.onSaveJournalSection,
                                        delete: function ($event) {
                                          return _vm.onDeleteJournalSection(
                                            $event
                                          )
                                        },
                                      },
                                    })
                                  : _vm.isOption(componentEl, "switch")
                                  ? _c(
                                      "div",
                                      {
                                        key: "dynamically" + index,
                                        staticClass:
                                          "journal-content generated-section",
                                      },
                                      [
                                        _vm.canEdit
                                          ? _c(
                                              "div",
                                              { staticClass: "content-menus" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "mini-actions",
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "edit",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.editNewJournalSection(
                                                              componentEl
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              width: "17",
                                                              height: "17",
                                                              viewBox:
                                                                "0 0 17 17",
                                                              "svg-inline": "",
                                                              role: "presentation",
                                                              focusable:
                                                                "false",
                                                              tabindex: "-1",
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                fill: "#fff",
                                                                "fill-rule":
                                                                  "evenodd",
                                                                d: "M1.5 12.78l8.34-8.575 2.14 2.197-8.35 8.56H1.5v-2.183zM12.125 1.853l2.15 2.203-1.23 1.26L10.9 3.119l1.225-1.265zM.75 16.498h3.19c.2 0 .39-.082.53-.226L15.865 4.6a.777.777 0 000-1.086L12.655.225a.74.74 0 00-.53-.225.74.74 0 00-.53.225L.22 11.92a.796.796 0 00-.22.543v3.268c0 .425.335.768.75.768z",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "delete",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteJournalSection(
                                                              componentEl.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              width: "20",
                                                              height: "22",
                                                              viewBox:
                                                                "0 0 20 22",
                                                              "svg-inline": "",
                                                              role: "presentation",
                                                              focusable:
                                                                "false",
                                                              tabindex: "-1",
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                "fill-rule":
                                                                  "evenodd",
                                                                d: "M15 4h4a1 1 0 110 2h-1v13a3 3 0 01-3 3H5a3 3 0 01-3-3V6H1a1 1 0 110-2h4V3a3 3 0 013-3h4a3 3 0 013 3v1zm-2 0V3a1 1 0 00-1-1H8a1 1 0 00-1 1v1h6zm3 2H4v13a1 1 0 001 1h10a1 1 0 001-1V6zm-9 4a1 1 0 112 0v6a1 1 0 11-2 0v-6zm4 0a1 1 0 112 0v6a1 1 0 11-2 0v-6z",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          { staticClass: "sub chapter" },
                                          [
                                            _c("header", [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(componentEl.title)
                                                ),
                                              ]),
                                              _c("hr"),
                                            ]),
                                            _c("div", {
                                              staticClass: "content-text",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  componentEl.subTitle
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ]
                      }
                    ),
                  ],
                  2
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "on-clickaway",
                        rawName: "v-on-clickaway",
                        value: _vm.awaySidebar,
                        expression: "awaySidebar",
                      },
                    ],
                    staticClass: "journal-sidebar",
                    class: {
                      "sidebar-small": _vm.sidebarSmallScreen,
                      active: _vm.openSidebar,
                    },
                  },
                  [
                    _c("header", [
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c("h2", [
                            _vm._v(
                              _vm._s(_vm.$t("pages.businessPlan.outline"))
                            ),
                          ]),
                          _c(
                            "ib-tooltip",
                            {
                              staticClass: "ml-4",
                              attrs: {
                                "popper-class": "medium center",
                                content: _vm.$t(
                                  "pages.businessPlan.addNewPage"
                                ),
                              },
                            },
                            [
                              _vm.canEdit
                                ? _c("el-button", {
                                    staticClass: "add-new-button",
                                    class: { "d-none": _vm.sidebarSmallScreen },
                                    attrs: {
                                      disabled: _vm.addButtonDisabled,
                                      type: "plus-round-xs",
                                      icon: "el-icon-plus",
                                    },
                                    on: { click: _vm.addCustomPage },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("hr"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "chapters" },
                      [
                        _c(
                          "draggable",
                          _vm._b(
                            {
                              staticClass: "list-group",
                              attrs: {
                                handle: ".drag-handle-single",
                                animation: "200",
                                move: _vm.checkMove,
                              },
                              on: {
                                start: function ($event) {
                                  _vm.isDragging = true
                                },
                                end: function ($event) {
                                  _vm.isDragging = false
                                },
                                change: _vm.changeOrder,
                              },
                              model: {
                                value: _vm.businessPlanSectionsFormated,
                                callback: function ($$v) {
                                  _vm.businessPlanSectionsFormated = $$v
                                },
                                expression: "businessPlanSectionsFormated",
                              },
                            },
                            "draggable",
                            _vm.dragOptions,
                            false
                          ),
                          [
                            _vm._l(
                              _vm.businessPlanSectionsFormated,
                              function (element, index) {
                                return [
                                  element.id === "section"
                                    ? [
                                        _c("p", { key: index }, [
                                          _vm._v(
                                            " " + _vm._s(element.title) + " "
                                          ),
                                          _vm.subscriptionIsFreeTrial &&
                                          element.paid
                                            ? _c("i", {
                                                staticClass:
                                                  "ib-icon-lock-2 o-50",
                                              })
                                            : _vm._e(),
                                        ]),
                                      ]
                                    : [
                                        _vm.getIsBusinessGuideSectionFinished(
                                          element.sectionName
                                        ) === false &&
                                        _vm.getBusinessGuideSectionRoute(
                                          element.sectionName
                                        )
                                          ? [
                                              element.id ||
                                              element.sectionName === "Custom"
                                                ? _c(
                                                    _vm.subscriptionIsFreeTrial &&
                                                      index >= 7 &&
                                                      index <= 24
                                                      ? "div"
                                                      : "router-link",
                                                    {
                                                      key:
                                                        "switchbar" +
                                                        element.id,
                                                      tag: "component",
                                                      staticClass:
                                                        "accordion-item drag-handle-single left",
                                                      class: {
                                                        inactive:
                                                          _vm.getIsBusinessGuideSectionFinished(
                                                            element.sectionName
                                                          ) === false,
                                                        "d-none":
                                                          _vm.subscriptionIsFreeTrial &&
                                                          index >= 7 &&
                                                          index <= 24,
                                                      },
                                                      attrs: {
                                                        to: {
                                                          name: _vm.getBusinessGuideSectionRoute(
                                                            element.sectionName
                                                          ),
                                                        },
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.setDialogUpgradeState(
                                                            true
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "left" },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "ib-icon-plus-math mr-2 color-font-light",
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "editable-title flex-column",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    element.title
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          : [
                                              element.id ||
                                              element.sectionName === "Custom"
                                                ? _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "switchbar" +
                                                        element.id,
                                                      staticClass:
                                                        "accordion-item drag-handle-single",
                                                      class: {
                                                        inactive:
                                                          _vm.subscriptionIsFreeTrial &&
                                                          index >= 7 &&
                                                          index <= 24,
                                                        "d-none":
                                                          _vm.subscriptionIsFreeTrial &&
                                                          index >= 7 &&
                                                          index <= 24,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.subscriptionIsFreeTrial &&
                                                          index >= 7 &&
                                                          index <= 24
                                                            ? _vm.setDialogUpgradeState(
                                                                true
                                                              )
                                                            : null
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "left" },
                                                        [
                                                          element.sectionName !==
                                                          "Cover"
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "mr-2 color-font-light cursor-move ib-icon-drag_icon",
                                                                class: {
                                                                  "d-none":
                                                                    _vm.subscriptionIsFreeTrial &&
                                                                    index >= 26,
                                                                  "ib-icon-plus-math":
                                                                    _vm.subscriptionIsFreeTrial &&
                                                                    index >=
                                                                      7 &&
                                                                    index <= 24,
                                                                },
                                                              })
                                                            : _vm._e(),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "editable-title flex-column cursor-pointer",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.scrollToPage(
                                                                      element.id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    element.title
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm.getIsBusinessGuideSectionFinished(
                                                        element.sectionName
                                                      ) !== false
                                                        ? [
                                                            (_vm.subscriptionIsFreeTrial &&
                                                              !(
                                                                index >= 7 &&
                                                                index <= 24
                                                              )) ||
                                                            !_vm.subscriptionIsFreeTrial
                                                              ? _c(
                                                                  "ib-tooltip",
                                                                  {
                                                                    attrs: {
                                                                      placement:
                                                                        "top",
                                                                      "popper-class":
                                                                        "plan-popper",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "tooltip-content",
                                                                        attrs: {
                                                                          slot: "content",
                                                                        },
                                                                        slot: "content",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "p",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "includeExcludeThisSection"
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "cursor-pointer o-50",
                                                                      class:
                                                                        _vm.isOption(
                                                                          element,
                                                                          "switch"
                                                                        )
                                                                          ? "ib-icon-eye"
                                                                          : "ib-icon-hide",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.onSaveJournalSection(
                                                                              element,
                                                                              "switch",
                                                                              true
                                                                            )
                                                                          },
                                                                      },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                            ],
                                      ],
                                ]
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _c("dialog-business-plan-quick-tour", {
            attrs: { visible: _vm.dialogQuickTourVisible },
            on: { skip: _vm.onTourComplete },
          }),
          _c("dialog-add-new-section", {
            attrs: {
              "dialog-add-new-section-visible": _vm.dialogAddNewSectionVisible,
              "page-data": _vm.newPageData,
            },
            on: {
              "on-save": _vm.onSaveNewJournalSection,
              "on-edit": _vm.onUpdateJournalSection,
              "on-close-dialog": _vm.closeJournalDialog,
            },
          }),
          _c("dialog-share", {
            attrs: {
              title: _vm.$t("dialogs.share.shareBusinessPlan"),
              type: "businessPlan",
              visible: _vm.dialogShareJournalVisible,
              token: _vm.sharedJournalToken,
            },
            on: { close: _vm.onCloseShareJournal },
          }),
          _c("dialog-generate", {
            attrs: {
              api: "/story-mode/journal/generate",
              format: _vm.generateFormat,
              "dialog-visible": _vm.generateDialog,
            },
            on: {
              close: function ($event) {
                _vm.generateDialog = false
              },
            },
          }),
          _vm.showGuideTour
            ? _c("business-plan-tour", {
                attrs: { "show-intro-dialog": "" },
                on: {
                  "tour-end": _vm.onTourComplete,
                  "intro-skip": _vm.onTourComplete,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }